export default __webpack_public_path__ + "static/media/bronze.44f901cc.svg";